"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.browserStorage = exports.browserLatency = exports.browserConnectionInfo = exports.audioAndVideoDevices = exports.audioFormats = exports.webGLHash = exports.webGL = exports.canvasHash = exports.touchSupport = exports.touchEnabled = void 0;
const utils_1 = require("../../utils/utils");
function touchEnabled() {
    /** If the event you are attempting to create with document.createEvent
     *  is not present, the browser throws an error and does not return false.
     *
     * Accordingly, we need to catch the error and return undefined so this item
     * is removed from the object.
     */
    try {
        if (document.createEvent('TouchEvent')) {
            return 'true';
        }
        else {
            return 'false';
        }
    }
    catch (_a) {
        return undefined;
    }
}
exports.touchEnabled = touchEnabled;
function touchSupport() {
    return {
        maxTouchPoints: navigator.maxTouchPoints > 0 ? `${navigator.maxTouchPoints}` : '',
        start: 'ontouchstart' in window,
    };
}
exports.touchSupport = touchSupport;
function canvasHash() {
    const strText = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ`~1!2@3#4$5%6^7&8*9(0)-_=+[{]}|;:',<.>/";
    try {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        if (context) {
            context.textBaseline = 'top';
            context.font = "14px 'Arial'";
            context.textBaseline = 'alphabetic';
            context.fillStyle = '#f60';
            context.fillRect(125, 1, 62, 20);
            context.fillStyle = '#069';
            context.fillText(strText, 2, 15);
            context.fillStyle = 'rgba(102, 204, 0, 0.7)';
            context.fillText(strText, 4, 17);
        }
        return utils_1.generateChecksum(canvas.toDataURL());
    }
    catch (err) {
        return undefined;
    }
}
exports.canvasHash = canvasHash;
function webGL() {
    const webGlObject = {
        vendor: ``,
        version: ``,
        shadingLanguageVersion: ``,
        gpu: ``,
        manufacturer: ``,
    }; // if empty, the user has disabled WebGL
    try {
        const context = document.createElement('canvas').getContext('webgl');
        if (context) {
            const debugInfo = context.getExtension('WEBGL_debug_renderer_info');
            if (context !== null || debugInfo !== null) {
                // webGlObject.renderer = gl.getParameter(gl.RENDERER);
                webGlObject.manufacturer = context.getParameter((debugInfo === null || debugInfo === void 0 ? void 0 : debugInfo.UNMASKED_VENDOR_WEBGL) || 0);
                webGlObject.gpu = context.getParameter((debugInfo === null || debugInfo === void 0 ? void 0 : debugInfo.UNMASKED_RENDERER_WEBGL) || 0);
                webGlObject.version = context.getParameter(context.VERSION);
                webGlObject.shadingLanguageVersion = context.getParameter(context.SHADING_LANGUAGE_VERSION);
                webGlObject.vendor = context.getParameter(context.VENDOR);
            }
            else {
                return webGlObject;
            }
        }
    }
    catch (_a) {
        /* nothing to see or do here, we can return the original object */
    }
    return webGlObject;
}
exports.webGL = webGL;
function webGLHash() {
    try {
        const gl = document.createElement('canvas').getContext('webgl');
        if (gl !== null) {
            const vertexPosBuffer = gl.createBuffer();
            //eslint-disable-next-line
            const vertexPosBufferAny = vertexPosBuffer;
            gl.bindBuffer(gl.ARRAY_BUFFER, vertexPosBuffer);
            const vertices = new Float32Array([
                -0.2,
                -0.9,
                0,
                0.4,
                -0.26,
                0,
                0,
                0.732134444,
                0,
            ]);
            gl.bufferData(gl.ARRAY_BUFFER, vertices, gl.STATIC_DRAW);
            const vShaderTemplate = 'attribute vec2 attrVertex;varying vec2 varyinTexCoordinate;uniform vec2 uniformOffset;void main(){varyinTexCoordinate=attrVertex+uniformOffset;gl_Position=vec4(attrVertex,0,1);}';
            const fShaderTemplate = 'precision mediump float;varying vec2 varyinTexCoordinate;void main() {gl_FragColor=vec4(varyinTexCoordinate,0,1);}';
            if (vertexPosBuffer) {
                // typecasting to bypass strict checking in a try/catch block
                // eslint-disable-next-line
                vertexPosBufferAny.itemSize = 3;
                vertexPosBufferAny.numItems = 3;
            }
            const p = gl.createProgram();
            const program = p;
            //eslint-disable-next-line
            const programAny = p;
            const vsh = gl.createShader(gl.VERTEX_SHADER);
            const vshader = vsh;
            const fsh = gl.createShader(gl.FRAGMENT_SHADER);
            const fshader = fsh;
            gl.shaderSource(vshader, vShaderTemplate);
            gl.compileShader(vshader);
            gl.shaderSource(fshader, fShaderTemplate);
            gl.compileShader(fshader);
            gl.attachShader(program, vshader);
            gl.attachShader(program, fshader);
            gl.linkProgram(program);
            gl.useProgram(program);
            programAny.vertexPosAttrib = gl.getAttribLocation(program, 'attrVertex');
            programAny.offsetUniform = gl.getUniformLocation(program, 'uniformOffset');
            gl.enableVertexAttribArray(programAny.vertexPosArray);
            gl.vertexAttribPointer(programAny.vertexPosAttrib, vertexPosBufferAny.itemSize, gl.FLOAT, !1, 0, 0);
            gl.uniform2f(programAny.offsetUniform, 1, 1);
            gl.drawArrays(gl.TRIANGLE_STRIP, 0, vertexPosBufferAny.numItems);
            if (gl.canvas !== null) {
                const c = gl.canvas;
                return utils_1.generateChecksum(c.toDataURL());
            }
        }
    }
    catch (_a) {
        /* No need to see or do anything here */
    }
    return undefined;
}
exports.webGLHash = webGLHash;
function audioFormats() {
    const audioList = [];
    try {
        const formatNames = [
            'audio/3gpp',
            'audio/3gpp2',
            'audio/AMR-NB',
            'audio/AMR-WB',
            'audio/GSM',
            'audio/aac',
            'audio/basic',
            'audio/flac',
            'audio/midi',
            'audio/mpeg',
            'audio/mp4; codecs="mp4a.40.2"',
            'audio/mp4; codecs="ac-3"',
            'audio/mp4; codecs="ec-3"',
            'audio/ogg; codecs="flac"',
            'audio/ogg; codecs="vorbis"',
            'audio/ogg; codecs="opus"',
            'audio/wav; codecs="1"',
            'audio/webm; codecs="vorbis"',
            'audio/webm; codecs="opus"',
            'audio/x-aiff',
            'audio/x-mpegurl',
        ];
        const element = document.createElement('audio');
        for (let i = 0; i < formatNames.length; i++) {
            const format = formatNames[i];
            if (!!element.canPlayType &&
                (element.canPlayType(format) === 'probably' ||
                    element.canPlayType(format) === 'maybe')) {
                const temp = format.replace(';', '');
                audioList.push(temp.replace(/"/g, ''));
            }
        }
    }
    catch (_a) {
        /** no need to see or do anything */
    }
    return audioList;
}
exports.audioFormats = audioFormats;
async function audioAndVideoDevices() {
    if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
        return [];
    }
    const deviceList = [];
    const devices = await navigator.mediaDevices
        .enumerateDevices()
        .then()
        .catch(() => {
        return [];
    });
    devices.forEach(device => {
        deviceList.push(device.kind + ': ' + device.label + ' id = ' + device.deviceId);
    });
    return deviceList;
}
exports.audioAndVideoDevices = audioAndVideoDevices;
function browserConnectionInfo() {
    let strConnection;
    try {
        // only on android
        //eslint-disable-next-line
        strConnection = navigator.connection.type;
    }
    catch (err) {
        /*nothing to see or do here*/
    }
    return strConnection;
}
exports.browserConnectionInfo = browserConnectionInfo;
function browserLatency() {
    const latency = {
        requestTime: undefined,
        networkLatency: undefined,
    };
    try {
        // supported by a number of modern browsers
        const perfData = window.performance.timing;
        latency.requestTime = `${perfData.responseStart - perfData.requestStart}`;
        latency.networkLatency = `${perfData.responseEnd - perfData.fetchStart}`;
    }
    catch (_a) {
        /* no need to see or do anything */
    }
    return latency;
}
exports.browserLatency = browserLatency;
function browserStorage() {
    return {
        local: window.localStorage ? 'true' : 'false',
        session: window.sessionStorage ? 'true' : 'false',
    };
}
exports.browserStorage = browserStorage;
//# sourceMappingURL=features.js.map